<template>
  <div>
    <div>
      <tabs class="px-3">
        <tab id="assign" :name="__('forms.KPIS.set_mbo')">
          <div class="row px-3">
            <div class="col-12 hidePrint" v-if="permissions.goals > 1"></div>
          </div>
          <div class="row px-3">
            <div class="col-12">
              <div class="row action-bar">
                <div class="form-group col-12">
                  <span class="text-primary ml-1 mr-4">{{
                    __("forms.KPIS.set_mbo")
                  }}</span>

                  <button
                    v-if="permissions.assign_objective > 1"
                    type="button"
                    class="btn btn--green mr-2"
                    data-toggle="modal"
                    :data-target="'#addGoalModal' + this.question_survey_id"
                  >
                    <span
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="__('views.GoalsQuestion.addGoal')"
                    >
                      {{ __("views.GoalsQuestion.addGoal") }}
                    </span>
                  </button>
                  <button
                    v-if="permissions.create_objective > 1"
                    type="button"
                    class="btn btn--green mr-2"
                    data-toggle="modal"
                    :data-target="'#createGoalModal' + this.question_survey_id"
                  >
                    <span
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="__('views.GoalsQuestion.createNewGoal')"
                    >
                      {{ __("views.GoalsQuestion.createNewGoal") }}
                    </span>
                  </button>
                  <!-- Handle Goal Button -->
                  <button
                    type="button"
                    data-toggle="modal"
                    :data-target="'#handleGoal' + this.question_survey_id"
                    class="btn btn--green mr-2"
                    @click="handleDataOwnerGoals()"
                    v-if="permissions.handle_owner_goals >= 1"
                  >
                    <span
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="__('views.GoalsQuestion.handleDataOwnerGoals')"
                    >
                      {{ __("views.GoalsQuestion.handleDataOwnerGoals") }}
                    </span>
                  </button>
                </div>
              </div>

              <table class="table table-custom-header">
                <thead>
                  <tr>
                    <th
                      v-if="permissions.goals > 1"
                      class="hidePrint"
                      style="width: 40px; max-width: 40px"
                    >
                      {{ __("misc.actions") }}
                    </th>
                    <th
                      v-if="permissions.goals > 1"
                      class="hidePrint"
                      style="width: 60px; max-width: 60px"
                    ></th>
                    <th>
                      {{ __("views.GoalsQuestion.goal") }}
                    </th>
                    <th
                      v-if="
                        permissions.show_assign_goal_to_role &&
                        permissions.show_assign_goal_to_role > 0
                      "
                    >
                      {{ __("views.GoalsQuestion.assigned_to_role") }}
                    </th>
                    <th style="width: 100px" v-if="show_weight">
                      {{ __("views.GoalsQuestion.weight") }} %
                    </th>
                    <th>
                      {{ __("views.GoalsQuestion.description") }}
                    </th>
                    <th
                      style="width: 150px"
                      v-if="
                        permissions.show_expired_at &&
                        permissions.show_expired_at > 0
                      "
                    >
                      {{ __("views.GoalsQuestion.expires_at") }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="!empty_values">
                  <tr v-for="(personGoal, index) in tableGoals" :key="index">
                    <td
                      v-if="permissions.goals > 1"
                      class="icon-button hidePrint"
                      style="width: 40px; max-width: 40px"
                    >
                      <a
                        @click="rmPersonGoal(personGoal)"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove hrt-button"
                      >
                        <i class="fas fa-trash"> </i>
                      </a>
                    </td>
                    <td
                      v-if="permissions.goals > 1"
                      class="icon-button hidePrint"
                      style="width: 60px; max-width: 60px"
                    >
                      <a
                        data-toggle="modal"
                        :data-target="'#editPersonalGoalModal' + question_survey_id"
                        @click="editPersonGoal(personGoal)"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit hrt-button mr-3"
                      >
                        <i class="fas fa-pencil"></i>
                      </a>
                    </td>
                    <td class="goal-name-width">{{ personGoal.goalName }}</td>
                    <td
                      v-if="
                        permissions.show_assign_goal_to_role &&
                        permissions.show_assign_goal_to_role > 0
                      "
                    >
                      {{ personGoal.roles }}
                    </td>
                    <td v-if="permissions.goals > 1 && show_weight">
                      <input
                        type="number"
                        v-model="personGoal.weight"
                        min="0"
                        class="form-control"
                        @change="updateGoal(personGoal, $event)"
                      />
                    </td>
                    <td
                      v-else-if="permissions.goals >= 1 && show_weight === true"
                    >
                      {{ personGoal.weight }}
                    </td>
                    <td style="width: 100px" v-else-if="show_weight === true">
                      {{ personGoal.weight }}
                    </td>

                    <td v-html="personGoal.goalDescription"></td>
                    <td
                      style="width: 150px"
                      v-if="
                        permissions.show_expired_at &&
                        permissions.show_expired_at > 0
                      "
                    >
                      {{ personGoal.due_date }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </tab>

        <tab
          id="evaluate"
          :name="__('views.CustomPermissions.Valutazione')"
          v-if="evaluate_tab_permissions"
        >
          <div class="row action-bar">
            <div class="form-group col-12">
              <span class="text-primary ml-1 mr-4"
                >{{
                  __(
                    "forms.EvaluationChart.questions.questions_setting.question33.evaluation_level"
                  )
                }}
              </span>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div
                v-for="(row, index) in goals_rows"
                v-bind:key="index"
                v-if="show_total_score && row.score"
                class="col-4"
              >
                <div
                  v-if="permissions[row.id] > 0"
                  class="card p-2 border-card shadow"
                >
                  <p class="text-primary">{{ row.label }}</p>
                  <p class="text-right h3">
                    {{ totalScores[index] }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="row px-3">
            <div
              class="col-12"
              v-for="(row, index) in goals_rows"
              v-bind:key="index"
            >
              <span v-if="permissions[row.id] > 0">
                <button
                  class="btn w-100 justify-content-between mb-2 mt-2"
                  type="button"
                  @click="toggle(index)"
                >
                  <div>
                    <label class="font-weight-bold"> {{ row.label }} </label> -
                    <label v-if="row.goal_date !== null">
                      {{
                        __("views.GoalsQuestion.goalDate") +
                        ": " +
                        row.goal_date
                      }}
                    </label>
                  </div>
                  <div v-if="show_total_score && row.score">
                    <label class="font-weight-bold">
                      {{
                        __(
                          "forms.EvaluationChart.questions.questions_setting.question12.prizeNames.total"
                        )
                      }}
                    </label>
                    <label>
                      {{ totalScores[index] }}
                    </label>
                    <i :ref="'chevron' + index" class="fas fa-chevron-up"></i>
                  </div>
                </button>

                <div :ref="`goal${index}`">
                  <table class="table table-custom-header">
                    <thead>
                      <tr v-if="row.score">
                        <th>{{ __("views.GoalsQuestion.goal") }}:</th>
                        <th style="width: 100px">
                          <span
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="
                              'Range ' + row.min_rating + ' - ' + row.rating
                            "
                          >
                            <i class="fas fa-info-circle"></i>
                          </span>
                          {{ __("views.GoalsQuestion.rating") }}
                        </th>
                        <th style="width: 100px" v-if="show_weight">
                          {{ __("views.GoalsQuestion.score") }}
                        </th>
                        <th style="width: 200px" v-if="row.set_date">
                          {{ __("views.GoalsQuestion.date") }}
                        </th>

                        <th v-if="show_column_note">
                          {{ __("views.GoalsQuestion.note") }}
                        </th>
                      </tr>
                      <tr v-else>
                        <th>
                          {{ __("views.GoalsQuestion.goal") }}
                        </th>
                        <th style="width: 200px" v-if="row.set_date">
                          {{ __("views.GoalsQuestion.date") }}
                        </th>
                        <th v-if="show_column_note">
                          {{ __("views.GoalsQuestion.note") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        row.score &&
                        userAnswers[index] !== undefined &&
                        !empty_values
                      "
                    >
                      <tr
                        v-for="(personGoal, person_goal_id) in tableGoals"
                        :key="person_goal_id"
                      >
                        <td>
                          {{ personGoal.goalName }}
                          <div v-if="personGoal.goalDescription" class="text-muted small mt-1">
                            <span v-html="personGoal.goalDescription"></span>
                          </div>
                        </td>
                        <td
                          style="width: 100px"
                          v-if="row.rating > 0 && permissions[index] > 1"
                        >
                          <div class="input-group">
                            <input
                              :class="'form-control ' + row.permission"
                              type="number"
                              :name="
                                'question[' +
                                question_survey_id +
                                '][' +
                                index +
                                '][' +
                                personGoal.goalId +
                                '][rating]'
                              "
                              v-model="
                                userAnswers[index][personGoal.goalId]['rating']
                              "
                              :min="row.min_rating"
                              :max="row.rating"
                              @change="calculatePercentRating($event)"
                            />
                          </div>
                        </td>
                        <td
                          style="width: 100px"
                          v-else-if="row.rating <= 0 && permissions[index] > 1"
                        >
                          <input
                            :class="'form-control ' + row.permission"
                            type="number"
                            :name="
                              'question[' +
                              question_survey_id +
                              '][' +
                              index +
                              '][' +
                              personGoal.goalId +
                              '][rating]'
                            "
                            v-model="
                              userAnswers[index][personGoal.goalId]['rating']
                            "
                            min="0"
                            @change="calculatePercentRating(event)"
                          />
                        </td>
                        <td v-else>
                          {{ userAnswers[index][personGoal.goalId]["rating"] }}
                        </td>

                        <td v-if="scores[index] !== undefined && show_weight">
                          {{ scores[index][personGoal.goalId] }}
                        </td>
                        <td v-else-if="show_weight">0</td>

                        <td style="width: 200px" v-if="row.set_date">
                          <input
                            class="form-control"
                            v-if="permissions[index] > 1"
                            type="date"
                            :name="
                              'question[' +
                              question_survey_id +
                              '][' +
                              index +
                              '][' +
                              personGoal.goalId +
                              '][date]'
                            "
                            v-model="
                              userAnswers[index][personGoal.goalId]['date']
                            "
                          />
                          <label v-else>
                            {{
                              userAnswers[index][personGoal.goalId][
                                "enchanted_date"
                              ]
                            }}
                          </label>
                        </td>

                        <td
                          v-if="
                            show_column_note &&
                            permissions['show_note_' + index] > 1
                          "
                        >
                          <ck-editor
                            :class="row.note_permission"
                            :name="
                              'question[' +
                              question_survey_id +
                              '][' +
                              index +
                              '][' +
                              personGoal.goalId +
                              '][note]'
                            "
                            :body="
                              userAnswers[index][personGoal.goalId]['note']
                            "
                            :enabled_paste_html="false"
                            v-model="
                              userAnswers[index][personGoal.goalId]['note']
                            "
                          >
                          </ck-editor>
                        </td>
                        <td
                          v-else-if="
                            show_column_note &&
                            permissions['show_note_' + index] === 1
                          "
                          v-html="userAnswers[index][personGoal.goalId]['note']"
                        >
                          
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      v-else-if="!row.score && userAnswers[index] !== undefined"
                    >
                      <tr
                        v-for="(personGoal, person_goal_id) in tableGoals"
                        :key="person_goal_id"
                      >
                        <td>
                          {{ personGoal.goalName }}
                          <div v-if="personGoal.goalDescription" class="text-muted small mt-1">
                            <strong>{{ __('views.GoalsQuestion.description') }}:</strong>
                            <span v-html="personGoal.goalDescription"></span>
                          </div>
                        </td>
                        <td v-if="row.set_date">
                          <input
                            v-if="permissions[index] > 1"
                            type="date"
                            class="form-control"
                            :name="
                              'question[' +
                              question_survey_id +
                              '][' +
                              index +
                              '][' +
                              personGoal.goalId +
                              '][date]'
                            "
                            v-model="
                              userAnswers[index][personGoal.goalId]['date']
                            "
                          />
                          <label v-else>
                            {{ userAnswers[index][personGoal.goalId]["date"] }}
                          </label>
                        </td>
                        <td
                          v-if="
                            show_column_note &&
                            permissions['show_note_' + index] > 1
                          "
                        >
                          <ck-editor
                            :class_required="row.permission"
                            :name="
                              'question[' +
                              question_survey_id +
                              '][' +
                              index +
                              '][' +
                              personGoal.goalId +
                              '][note]'
                            "
                            :body="
                              userAnswers[index][personGoal.goalId]['note']
                            "
                            :enabled_paste_html="false"
                            v-model="
                              userAnswers[index][personGoal.goalId]['note']
                            "
                          >
                          </ck-editor>
                          <input
                            :class="'form-control ' + row.permission"
                            type="hidden"
                            :name="
                              'question[' +
                              question_survey_id +
                              '][' +
                              index +
                              '][' +
                              personGoal.goalId +
                              '][rating]'
                            "
                          />
                        </td>
                        <td
                          v-else-if="
                            show_column_note &&
                            permissions['show_note_' + index] === 1
                          "
                          v-html="userAnswers[index][personGoal.goalId]['note']"
                        >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </span>
            </div>
          </div>
        </tab>
      </tabs>
    </div>

    <!-- modals -->

    <!-- Associate Goal to Evaluation Chart -->
    <div
      class="modal fade"
      :id="'addGoalModal' + this.question_survey_id"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'addGoalModalLabel' + this.question_survey_id"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" :id="'addGoalModalLabel' + this.question_survey_id">
              {{ __("views.GoalsQuestion.addGoal") }}
            </h5>
            <button
              type="button"
              ref="addGoalCloseModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
              <div class="form-group">
                <label>{{ __("views.GoalsQuestion.goal") }}</label>
                <select class="form-control" v-model="newGoal">
                  <option>---</option>
                  <option
                    v-for="goal in newGoalsSelect"
                    :value="goal.id"
                    :key="goal.id"
                  >
                    {{ goal.name }}
                  </option>
                </select>
              </div>
              <div class="form-group" v-if="show_weight">
                <label>{{ __("views.GoalsQuestion.weight") }}</label>
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  v-model="newWeight"
                />
              </div>
              <div
                class="form-group"
                v-if="
                  permissions.show_expired_at && permissions.show_expired_at > 0
                "
              >
                <label>{{ __("views.GoalsQuestion.expires_at") }}</label>
                <input type="date" class="form-control" v-model="newDueDate" />
              </div>
              <div
                class="form-group include-rol"
                v-if="
                  permissions.show_assign_goal_to_role &&
                  permissions.show_assign_goal_to_role > 0
                "
              >
                <label>{{ __("views.GoalsQuestion.assigned_to_role") }}</label>
                <input
                  type="checkbox"
                  value="1"
                  class=""
                  v-model="includeToRole"
                />
              </div>
              <div v-else>
                <input
                  type="hidden"
                  value="0"
                  class=""
                  v-model="includeToRole"
                />
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn--green"
                  @click="addNewPersonGoal()"
                >
                  <i class="fas fa-plus-circle mr-2"></i
                  >{{ __("views.GoalsQuestion.addGoal") }}
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create Goal -->
    <div
      class="modal fade"
      :id="'createGoalModal' + this.question_survey_id"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'createGoalModalLabel' + this.question_survey_id"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" :id="'createGoalModalLabel' + this.question_survey_id">
              {{ __("views.GoalsQuestion.createGoal") }}
            </h5>
            <button
              type="button"
              ref="createGoalCloseModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">                          
              <div class="form-group">
                <label>{{ __("forms.goals.name") }}</label>
                <input type="text" class="form-control" v-model="newGoalName" />
              </div>
              
              <div class="form-group">
                <label>{{ __("forms.goals.description") }}</label>
                <ck-editor
                  :textarea_prop_id="'create_modal_goal_question_'+ this.question_survey_id"
                  :name="'newGoalDescription'"
                  :body="newGoalDescription"
                  :enabled_paste_html="false"
                  @update:description="handleDescriptionUpdate"
                >
                </ck-editor>
              </div>

              <div class="form-group" v-if="show_weight">
                <label>{{ __("views.GoalsQuestion.weight") }}</label>
                <input type="number" class="form-control" min="0" v-model="newGoalWeight" />
              </div>

              <div class="form-group" v-if="permissions.show_expired_at && permissions.show_expired_at > 0">
                <label>{{ __("views.GoalsQuestion.expires_at") }}</label>
                <input type="date" class="form-control" v-model="newGoalDueDate"/>
              </div>

              <div class="form-group" v-if="permissions.show_assign_goal_to_role && permissions.show_assign_goal_to_role > 0 ">
                <label>{{ __("views.GoalsQuestion.assigned_to_role") }}</label>
                <input type="checkbox" value="1" class="" v-model="newGoalIncludeToRole" />
              </div>
              <div v-else>
                <input type="hidden" value="0" class="" v-model="newGoalIncludeToRole" />
              </div>

          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn--green"
              @click="createNewGoal()"
            >
              <i class="fas fa-plus-circle mr-2"></i>{{ __("misc.save") }}
            </button>
          </div>
        </div>        
      </div>
    </div>

    <!-- Edit Personal Goal -->
    <div
      class="modal fade"
      :id="'editPersonalGoalModal' + this.question_survey_id"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'editPersonalGoalModalLabel' + this.question_survey_id"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" :id="'editPersonalGoalModalLabel' + this.question_survey_id">
              {{ __("views.GoalsQuestion.editGoal") }}
            </h5>
            <button
              type="button"
              ref="editPersonalGoalCloseModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
              <div class="form-group">
                <label>{{ __("forms.goals.name") }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="personalGoalName"
                />
              </div>
              <div class="form-group">
                <label>{{ __("forms.goals.description") }}</label>
                <ck-editor
                  :textarea_prop_id="'edit_modal_goal_question_' + question_survey_id"
                  :name="'personalGoalDescription'"
                  :body="personalGoalDescription"
                  :enabled_paste_html="false"
                  @update:description="handleDescriptionUpdate"
                >
                </ck-editor>
              </div>

              <div class="form-group" v-if="show_weight">
                <label>{{ __("views.GoalsQuestion.weight") }}</label>
                <input type="number" class="form-control" min="0" v-model="personalGoalWeight" />
              </div>

              <div class="form-group" v-if="permissions.show_expired_at && permissions.show_expired_at > 0">
                <label>{{ __("views.GoalsQuestion.expires_at") }}</label>
                <input type="date" class="form-control" v-model="personalGoalDueDate"/>
              </div>

              <div class="form-group" v-if="permissions.show_assign_goal_to_role && permissions.show_assign_goal_to_role > 0 ">
                <label>{{ __("views.GoalsQuestion.assigned_to_role") }}</label>
                <input type="checkbox" value="1" class="" v-model="personalGoalIncludeToRole" />
              </div>
              <div v-else>
                <input type="hidden" value="0" class="" v-model="personalGoalIncludeToRole" />
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn--green"
                  @click="updatePersonGoal()"
                >
                  <i class="fas fa-plus-circle mr-2"></i>{{ __("misc.save") }}
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modals handle goals-->
    <div
      class="modal fade"
      :id="'handleGoal' + this.question_survey_id"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'handleDataOwnerGoals' + this.question_survey_id"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" :id="'handleDataOwnerGoals' + this.question_survey_id">
              <b>{{ __("views.GoalsQuestion.handleDataOwnerGoals") }}</b>
            </h5>
            <button
              type="button"
              ref="handleDataOwnerGoals"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-2">
              <i>{{ __("forms.goal.handle.info") }}</i>
            </div>
            <table class="table table-custom-header">
              <thead>
                <tr>
                  <th style="width: 80px; max-width: 80px">
                    {{ __("forms.goal.actions") }}
                  </th>
                  <th>{{ __("forms.goal.name") }}</th>
                  <th>{{ __("forms.goal.description") }}</th>
                  <th>{{ __("forms.goal.weigth") }}</th>
                  <th>{{ __("forms.goal.assignees") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(singleGoal, index) in dataOwnerGoals" :key="index">
                  <td
                    style="width: 80px; max-width: 80px"
                    class="cursor-pointer"
                  >
                    <a
                      @click="rmGoal(singleGoal)"
                      class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove hrt-button"
                    >
                      <i class="fas fa-trash"> </i>
                    </a>
                  </td>
                  <td>{{ singleGoal.name }}</td>
                  <td>
                    {{
                      singleGoal.description
                        ? singleGoal.description.replace(/<\/?[^>]+(>|$)/g, "")
                        : ""
                    }}
                  </td>
                  <td>{{ singleGoal.weight }}</td>
                  <td class="cursor-pointer">
                    {{ singleGoal.people.length }}
                    <i
                      v-my-title="{ func: pluckPeople, param: singleGoal }"
                      class="fas fa-info-circle"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-custom-header thead tr th {
  background: transparent;
  color: #1767a2 !important;
  font-weight: 800 !important;
}
</style>

<script>
Vue.directive("my-title", {
  bind: function (el, binding) {
    const func = binding.value.func;
    const param = binding.value.param;
    if (typeof func === "function") {
      const newTitle = func(param);
      el.setAttribute("title", newTitle);
    }
  },
});
export default {
  mounted() {
    this.populateGoalsTables();
  },
  props: {
    permissions: {
      type: Object,
      required: true,
    },
    show_column_note: {
      type: Boolean,
      required: true,
    },
    goals_rows: {
      type: Object,
      required: true,
    },
    data_route_rating: {
      type: String,
      required: true,
    },
    url_add_goal: {
      type: String,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    role_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    owner_person_id: {
      type: Number,
      required: true,
    },
    group_id: {
      type: Number,
      required: true,
    },
    assigned_by: {
      type: Number,
      required: true,
    },
    show_weight: {
      type: Boolean,
      required: true,
    },
    show_total_score: {
      type: Boolean,
      required: true,
    },
    evaluate_tab_permissions: {
      type: Boolean,
      required: true,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
    type_of_calculation: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      //Associate Goal
      newGoal: null,
      newWeight: 100,
      newDueDate: null,
      includeToRole: 0,
      newGoalsSelect: [],
      //Create New Goal
      newGoalName: null,
      newGoalDescription: "",
      newGoalWeight: 100,
      newGoalDueDate: null,
      newGoalIncludeToRole: 0,
      //Personal Goals
      personalGoalId: null,
      personalGoalAssociatedId: null,
      personalGoalName: "",
      personalGoalDescription: "",
      personalGoalWeight: 100,
      personalGoalDueDate: null,
      personalGoalIncludeToRole: 0,
      tableGoals: [],
      userAnswers: [],
      scores: [],
      totalScores: [],

      //default
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      userUrl: this.is_admin ? "" : "-user",
      newClientName: null,
      newProjectName: null,

      dataOwnerGoals: [],
    };
  },
  methods: {
    handleDescriptionUpdate({ name, value }) {
      if (name === "newGoalDescription") {
        this.newGoalDescription = value;
      } else if (name === "personalGoalDescription") {
        this.personalGoalDescription = value;
      }
    },
    toggle(index) {
      this.$refs[`goal${index}`][0].classList.toggle("d-none");
      this.$refs[`chevron${index}`][0].classList.toggle("fa-rotate-180");
    },
    hideAll() {
      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("goal")
      );
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron")
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("fa-rotate-180");
      });
    },
    showAll() {
      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("goal")
      );
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron")
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("fa-rotate-180");
      });
    },
    handleDataOwnerGoals() {
      axios
        .get("/get-data-owner-goal-chart/" + this.group_id)
        .then((response) => {
          this.dataOwnerGoals = response.data;
        });
    },
    populateGoalsTables() {
      axios
        .get("/get-goals-tables-chart" + this.userUrl, {
          params: {
            question_id: this.question_survey_id,
            goals_group_id: this.group_id,
            evaluation_chart_id: this.evaluation_chart_id,
          },
        })
        .then((response) => {
          this.tableGoals = response.data.tableGoals;
          this.userAnswers = response.data.answers;
          this.newGoalsSelect = response.data.newGoalsSelect;
          $("#saveHidden").trigger("click");
          this.calculatePercentRating();
        })
        .catch(function (error) {
          alert(error);
        });
    },
    createNewGoal() {
      if (!this.newGoalName) {
        Vue.$toast.open({
          message: this.__('views.GoalsQuestion.goal_name_required'),
          type: "error",
          position: "top-right",
        });
        return;
      }

      if (!this.newGoalWeight || this.newGoalWeight === 0) {
        Vue.$toast.open({
          message: this.__('views.GoalsQuestion.goal_weight_required'),
          type: "error",
          position: "top-right",
        });
        return;
      }

      axios
        .post("/goals/store-user", {
          goal: {
            group_id: this.group_id,
            name: this.newGoalName,
            description: this.newGoalDescription,
            evaluation_chart_owner_person_id: this.owner_person_id,
            deadline: {
              expires_at: this.newGoalDueDate,
            },
            role_id: this.role_id,
            set_role: this.newGoalIncludeToRole,
            addFromChart: true,
            weight: this.newGoalWeight
          },
        })
        .then((response) => {
          this.newGoalName = null;
          this.newGoalDescription = " ";
          this.newGoalWeight = 100;
          this.newGoalDueDate = null;
          this.newGoalIncludeToRole = 0;
          Vue.$toast.open({
            message: this.__("misc.created_succesfully"),
            type: "success",
            position: "top-right",
          });
          this.$refs.createGoalCloseModal.click();
          this.populateGoalsTables();
        })
        .catch(function (error) {
          Vue.$toast.open({
            message: error.message,
            type: "error",
            position: "top-right",
          });
        });
    },
    addNewPersonGoal() {
      if (!this.newGoal) {
        Vue.$toast.open({
          message:  this.__('views.GoalsQuestion.goal_name_required'),
          type: "error",
          position: "top-right",
        });
        return;
      }

      if (this.newWeight === 0 || this.newWeight === 0) {
        Vue.$toast.open({
          message: this.__('views.GoalsQuestion.goal_weight_required'),
          type: "error",
          position: "top-right",
        });
        return;
      }

      axios
        .post("/people-goals" + this.userUrl, {
          people_goal: {
            goal_id: this.newGoal,
            weight: this.newWeight,
            person_id: this.owner_person_id,
            assigned_by_person_id: this.assigned_by,
          },
          deadline: {
            expires_at: this.newDueDate,
          },
          role_id: this.role_id,
          set_role: this.includeToRole,
        })
        .then((response) => {
          Vue.$toast.open({
            message: this.__("misc.created_succesfully"),
            type: "success",
            position: "top-right",
          });
          this.$refs.addGoalCloseModal.click();
          this.populateGoalsTables();
        })
        .catch(function (error) {
          Vue.$toast.open({
            message: error.message,
            type: "error",
            position: "top-right",
          });
        });
    },
    updateGoal(personGoal, event) {
      axios
        .put("/update-person-goal-chart" + this.userUrl, {
          evaluation_chart: this.evaluation_chart_id,
          people_goal: personGoal.id,
          question_survey: this.question_survey_id,
          weight: event.target.value,
        })
        .then((response) => {
          this.calculatePercentRating();
          Vue.$toast.open({
            message: __("misc.updated_succesfully"),
            type: "success",
            position: "top-right",
          });
        })
        .catch(function (error) {
          Vue.$toast.open({
            message: error.message,
            type: "error",
            position: "top-right",
          });
        });
    },
    editPersonGoal(personGoal) {
      this.personalGoalId = personGoal.id;
      this.personalGoalAssociatedId = personGoal.goalId;
      this.personalGoalName = personGoal.goalName;
      this.personalGoalDescription = personGoal.goalDescription ?? "";
      this.personalGoalIncludeToRole = personGoal.roles && personGoal.roles.trim() !== "" ? true : false;
      if (personGoal.due_date) {
        try {
          const [day, month, year] = personGoal.due_date.split('/').map(Number);

          if (
            !Number.isInteger(day) || day < 1 || day > 31 ||
            !Number.isInteger(month) || month < 1 || month > 12 ||
            !Number.isInteger(year) || year < 1000 || year > 9999
          ) {
            throw new Error('Invalid date components');
          }

          const date = new Date(year, month - 1, day);

          if (date.getDate() !== day || date.getMonth() + 1 !== month || date.getFullYear() !== year) {
            throw new Error('Invalid date object');
          }

          const formattedYear = date.getFullYear();
          const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
          const formattedDay = String(date.getDate()).padStart(2, '0');

          this.personalGoalDueDate = `${formattedYear}-${formattedMonth}-${formattedDay}`;
        } catch (error) {
          console.error('Error parsing date:', error.message);
          this.personalGoalDueDate = '';
        }
      } else {
        this.personalGoalDueDate = '';
      }   
      this.personalGoalWeight = personGoal.weight;
    },
    updatePersonGoal() {
      if (this.personalGoalId === null || this.personalGoalName === null) {
        Vue.$toast.open({
          message: "Invalid data",
          type: "error",
          position: "top-right",
        });
        return;
      }
      axios
        .put("/goals/" + this.personalGoalAssociatedId + "/update-user", {
          goal: {
            id: this.personalGoalId,
            name: this.personalGoalName,
            description: this.personalGoalDescription,
            deadline: {
              expires_at: this.personalGoalDueDate,
            },
            role_id: this.role_id,
            weight: this.personalGoalWeight,
            set_role: this.personalGoalIncludeToRole,
            addFromChart: true
          },
        })
        .then((response) => {
          Vue.$toast.open({
            message: this.__("misc.updated_succesfully"),
            type: "success",
            position: "top-right",
          });
          this.$refs.editPersonalGoalCloseModal.click();
          this.populateGoalsTables();
        })
        .catch((error) => {
          Vue.$toast.open({
            message: error.message,
            type: "error",
            position: "top-right",
          });
          this.$refs.editPersonalGoalCloseModal.click();
          this.populateGoalsTables();
        });
    },
    rmPersonGoal(personGoal) {
      Vue.swal
        .fire({
          title: "Vuoi rimuovere l'associazione con questo obiettivo?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("/delete-person-goal-chart" + this.userUrl, {
                params: {
                  evaluation_chart: this.evaluation_chart_id,
                  people_goal: personGoal.id,
                  question_survey: this.question_survey_id,
                },
              })
              .then((response) => {
                let message = this.__("misc.deleted_succesfully");
                Vue.$toast.open({
                  message: message,
                  type: "success",
                  position: "top-right",
                });
                this.populateGoalsTables();
              })
              .catch(function (error) {
                Vue.$toast.open({
                  message: error.message,
                  type: "error",
                  position: "top-right",
                });
                this.populateGoalsTables();
              });
          }
        });
    },
    calculatePercentRating(event) {
      if (!this.goals_rows) {
        return;
      }

      //calling ajax for calculate the values
      axios
        .post(decodeURI(this.data_route_rating), {
          userAnswers: this.userAnswers,
          goals_rows: this.goals_rows,
          table_goals: this.tableGoals,
          type_of_calculation: this.type_of_calculation,
          evaluation_chart_id: this.evaluation_chart_id,
        })
        .then((response) => {
          this.scores = response.data.row_final_ratings;
          this.totalScores = response.data.sumRatings;
        })
        .catch(function (error) {
          alert(error);
        });
    },
    pluckPeople(param) {
      var result = "";
      param.people.sort((a, b) => a.surname.localeCompare(b.surname));
      for (var i = 0; i < param.people.length; i++) {
        result += param.people[i].surname + " " + param.people[i].name + "\n";
      }
      return result;
    },
    rmGoal(singleGoal) {
      Vue.swal
        .fire({
          title: "Vuoi eliminare questo obiettivo?",
          text: "Le risposte collegate verranno eliminate",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("/delete-data-owner-goal-chart/" + singleGoal.id)
              .then((response) => {
                this.handleDataOwnerGoals();
                this.populateGoalsTables();
              })
              .catch(function (error) {
                Vue.$toast.open({
                  message: error.message,
                  type: "error",
                  position: "top-right",
                });
                this.populateGoalsTables();
              });
          }
        });
    },
  },
};
</script>